module.exports = __webpack_public_path__ + "static/media/delete_icon_vector.35c05a43.svg";